import { Container, Sprite } from 'pixi.js';
import { getGameSize, IGameSizeInfo } from '../../../Config/Levels';
import Core, { GameOrientation } from '../../../Core/Core';
import { gameConfig } from '../../../index';
import { HudActions, HudEmitter } from '../../../Managers/Hud/HudEmitter';
import { PlayerCoins } from '../../Shared/PlayerCoins';
import { MovesCounter } from '../Shared/MovesCounter';
import { GameBoosters } from './GameBoosters';

export class BottomUi extends Container {
    public boosters: GameBoosters;
    public readonly movesCounter: MovesCounter;
    public readonly wallet: PlayerCoins;
    private readonly bg: PIXI.Sprite;

    constructor(currentBoosters: string[]) {
        super();

        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;

        const bgId = isPortrait ? 'booster-bg' : 'vertical-bg';
        const bg = (this.bg = new Sprite(PIXI.utils.TextureCache['gameui/' + bgId]));

        this.resize(getGameSize());

        const boosters = new GameBoosters(this.selectBooster.bind(this), currentBoosters, bg);
        this.boosters = boosters;

        const walletWidth = isPortrait ? bg.width * 0.5 : bg.width * 0.6;
        const walletHeight = isPortrait ? bg.height * 0.35 : bg.height * 0.3;

        this.wallet = new PlayerCoins(
            walletWidth,
            walletHeight,
            Core.store.getState().StateCurrency.coin,
            !isPortrait
        );
        this.wallet.x = isPortrait ? bg.width * 0.19 : bg.width * 0.5;
        this.wallet.y = isPortrait ? bg.height * 0.31 : bg.height * 0.11;

        if (!isPortrait) {
            this.addChild(bg);
            //@ts-ignore
            this.addChild(boosters, this.wallet);
        } else {
            this.addChild(bg);
            const movesCounter = (this.movesCounter = new MovesCounter(
                bg.width,
                bg.height,
                isPortrait
            ));
            movesCounter.x = bg.width * 0.61;
            movesCounter.y = this.wallet.y;
            //@ts-ignore
            bg.addChild(boosters, this.wallet, this.movesCounter);
        }
    }

    public resize(gameSize: IGameSizeInfo) {
        const isPortrait = Core.orientation === GameOrientation.PORTRAIT;
        if (!isPortrait) {
            this.bg.scale.set(1.35);
            const gameWidth = gameConfig.game_width;
            const xOffset = gameSize.xOffset;
            this.x = gameWidth + xOffset * 1.5 - this.bg.width * 0.5;
            this.y = gameSize.gameHeight * 0.5 - this.bg.height * 0.5;
        } else {
            this.bg.y = gameSize.gameHeight - this.bg.height;
        }
    }

    public getButton(id: string) {
        return this.boosters.getButton(id);
    }

    public showBoosters(available: string[], free: string[]) {
        this.boosters.showAvailable(available, free);
    }

    private selectBooster(boosterId: string) {
        if (this.boosters.getButton(boosterId).enabled) {
            // this.emit('booster-select', boosterId);
            HudEmitter.instance.emit(HudActions.GAME_BOOSTER_SELECT, boosterId);
        }
    }
}
